"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _IconBase = _interopRequireDefault(require("./IconBase"));
var ChevronLeftIcon = function ChevronLeftIcon(props) {
  return _react["default"].createElement(_IconBase["default"], props, _react["default"].createElement("g", null, _react["default"].createElement("defs", null, _react["default"].createElement("polygon", {
    points: "-507,-1597.791 -508.209,-1599 -513,-1594.209 -517.791,-1599 -519,-1597.791 -514.209,-1593 -519,-1588.209 -517.791,-1587 -513,-1591.791 -508.209,-1587 -507,-1588.209 -511.791,-1593 \t\t"
  })), _react["default"].createElement("g", null, _react["default"].createElement("defs", null, _react["default"].createElement("rect", {
    x: "-688",
    y: "-3317",
    width: "1440",
    height: "6698"
  })))), _react["default"].createElement("g", null, _react["default"].createElement("polyline", {
    fill: "none",
    strokeWidth: "6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "43.767,58.04 18.205,32.478 43.767,6.916 \t"
  })));
};
ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var _default = ChevronLeftIcon;
exports["default"] = _default;
ChevronLeftIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ChevronLeftIcon"
};
if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["icons/ChevronLeftIcon.js"] = {
    name: "ChevronLeftIcon",
    docgenInfo: ChevronLeftIcon.__docgenInfo,
    path: "icons/ChevronLeftIcon.js"
  };
}